export default __webpack_public_path__ + "static/media/756-tile.500b4cb7.svg";